import styled from "styled-components";

export const FooterSection = styled("footer")`
  background: #fff;
  padding: 2.5rem 0;
`;

export const FooterWrapper = styled("div")`
  opacity: 1;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
`;

export const HorizontalLine = styled("div")`
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  margin-bottom: 2rem;
`;

export const FooterTopRow = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`;

export const FooterLogoTagline = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LargeText = styled("div")`
  font-size: 18px;
  line-height: 1.4;
  max-width: 400px;
`;

export const BoldText = styled("strong")`
  font-weight: 600;
`;

export const FooterCTA = styled("div")`
  display: flex;
  align-items: center;
`;

export const LaunchButton = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 24px;
  background-color: transparent;
  color: var(--primary-color, #f9c0f5);
  border: 1px solid var(--primary-color, #f9c0f5);
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  &:hover {
    background-color: var(--primary-color, #f9c0f5);
    color: white;
  }
`;

export const FooterMenusWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const FooterMenuColumn = styled("div")`
  min-width: 200px;
`;

export const TextBold = styled("div")`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 1rem;
  color: #1a1a1a;
`;

export const FooterLinks = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FooterLink = styled("a")`
  color: #4d4d4d;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s ease;
  
  &:hover {
    color: var(--primary-color, #f9c0f5);
  }
`;

export const FooterContact = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  color: #4d4d4d;
  font-size: 15px;
  line-height: 1.5;
`;

export const FooterBottomRow = styled("div")`
  padding-top: 2rem;
  border-top: 1px solid #e6e6e6;
`;

export const FooterCopyrightWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SmallText = styled("div")`
  font-size: 14px;
  color: #6e6e6e;
`;

export const CopyrightDivider = styled("div")`
  font-size: 14px;
  color: #6e6e6e;
`;

// Keep these exports for backward compatibility
export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled("a")`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const Extra = styled("section")`
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
  display: none;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #18216d;
  font-size: 14px;
  width: 70%;
`;

export const Large = styled(NavLink)`
  font-size: 16px;
  color: #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: var(--primary-color, #f9c0f5);
    text-underline-position: under;
    text-decoration: var(--primary-color, #f9c0f5) wavy underline;
  }
`;

export const Chat = styled("p")`
  color: var(--text-color, #18216d);
  max-width: fit-content;
  border-bottom: 1px solid var(--text-color, #18216d);
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid var(--primary-color, #f9c0f5);
    color: var(--primary-color, #f9c0f5);
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: #1a744e;
    }
  }
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;